import { Company } from "@domain/CRM/company";
import { Region } from "@domain/CRM/region";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_Regions extends GetAPI_Base<Region> {
	constructor() {
		super("regions", Region);
	}

	public async byCompany(company: Company, fresh?: boolean) {
		const regions = await super.byFilter({ fields: { companyIds: [company.name] } }, fresh);
		return regions;
	}
}

export class RegionsAPI extends DataAPI_Base<Region> {
	get: GetAPI_Regions;
	constructor() {
		super("regions", Region);
		this.get = new GetAPI_Regions();
	}
}
